import type { FC } from 'react';
interface InfluencerIconProps {
  icon: string;
  alt: string;
  size?: number;
}
export const InfluencerIcon: FC<InfluencerIconProps> = ({
  icon,
  alt,
  size = 32
}) => <img src={icon} alt={alt} width={size} height={size} style={{
  borderRadius: '50%',
  border: '2px solid rgba(62, 71, 90, 1)'
}} data-sentry-component="InfluencerIcon" data-sentry-source-file="influencer-icon.tsx" />;